import React from 'react'
// libs
import { useDispatch } from 'react-redux'
// redux
import { hideModal as hideModalAction } from 'store/reducers/modals'
// components
import { Tab } from '@mui/material'
import { PlanKPIActionsMenu } from 'components/CTAs'
import { LoaderWithOverlay, Scrollbar, Tabs } from 'components/UI'
// hooks
import { useModalData } from 'hooks'
// view components
import ActivitiesListContainer from 'containers/Activities/components/ActivitiesList'
import CompleteReviewContainer from 'containers/Review/CompleleReview'
import DetailsSection from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection'
import FullModalContainer from '../../components/FullModalContainer'
import KPIResultsList from 'components/Modals/PlanItems/KPI/MinimizedModal/components/KPIResultsList'
import KPIReviewsList from 'components/Modals/PlanItems/KPI/MinimizedModal/components/ReviewsList'
import QuickResultEnter from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/QuickResultEnter'
// constants
import { Modals, ENTITIES } from 'constants/index'
// views
import {
  SubHeader,
  ContentWrapper,
  FormWrapper,
  DetailsWrapper,
  FullModalHeader as Header,
  CollapseIcon,
  ActivitiesWrapper
} from 'components/Modals/PlanItems/styles'
// themes
import { CloseIcon } from 'components/UI/Icons'
import { EllipsizedText } from 'themes/views/generic'
// graphql
import { PLAN_KPI_ACTIVITIES_LIST_QUERY } from 'graphql/planKPIs/queries'
// hocs
import withKPI from '../withKPI'
// utils
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
// context
import { KPIContext } from 'context'
// types
import { LogEntityTypes } from 'types/graphql'

const KPIFullModal = () => {
  const dispatch = useDispatch()

  const { hideModal, modalData } = useModalData({ modalType: Modals.KPI_FULL_MODAL })

  const { entity, isLoading, plan } = React.useContext(KPIContext)

  const [tab, setTab] = React.useState(0)
  const [isReviewExist, setIsReviewExist] = React.useState(false)

  const handleSetIsReviewExist = (value) => setIsReviewExist(value)

  const handleClose = () => {
    dispatch(hideModalAction(Modals.KPI_MINIMIZED_MODAL))
    dispatch(hideModalAction(Modals.KPI_FULL_MODAL))
  }

  const handleSetTab = (_, value) => setTab(value)

  const { width, isOpen } = modalData

  const isKPIPeriodExist = !isEmpty(get(entity, 'recurrence'))

  const scrollbarHeight = React.useMemo(() => {
    if (isReviewExist && isKPIPeriodExist) {
      return 'calc(100% - 164px)'
    }
    if (isReviewExist || isKPIPeriodExist) {
      return 'calc(100% - 82px)'
    }
    return '100%'
  }, [isReviewExist, isKPIPeriodExist])

  return (
    <FullModalContainer hideModal={hideModal} isOpen={isOpen} width={width}>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && (
        <>
          <Header>
            <EllipsizedText style={{ maxWidth: '95%' }}>{get(entity, 'description')}</EllipsizedText>
            <CollapseIcon onClick={hideModal} />
            <CloseIcon onClick={handleClose} />
          </Header>
          <ContentWrapper>
            <FormWrapper>
              <QuickResultEnter isFullModal />
              <CompleteReviewContainer
                entity={{ ...entity, entityType: ENTITIES.PLAN_KPI }}
                handleOnMount={handleSetIsReviewExist}
                hideModal={hideModal}
                isFullModal
              />
              <Scrollbar style={{ height: scrollbarHeight }}>
                <DetailsSection disableDrag hideModal={hideModal} isFullModal />
              </Scrollbar>
            </FormWrapper>
            <DetailsWrapper>
              <SubHeader>
                {!plan.locked && <PlanKPIActionsMenu plan={plan} entity={entity} hideParent={hideModal} />}
                <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
                  <Tab label='Activity' />
                  <Tab label='Results' />
                  <Tab label='Reviews' />
                </Tabs>
              </SubHeader>
              {tab === 0 && (
                <ActivitiesWrapper>
                  <ActivitiesListContainer
                    entity={{ ...entity, entityType: LogEntityTypes.Kpi }}
                    query={PLAN_KPI_ACTIVITIES_LIST_QUERY}
                    variables={{
                      filter: { entityId: get(entity, 'id') }
                    }}
                  />
                </ActivitiesWrapper>
              )}
              {tab === 1 && <KPIResultsList />}
              {tab === 2 && <KPIReviewsList />}
            </DetailsWrapper>
          </ContentWrapper>
        </>
      )}
    </FullModalContainer>
  )
}

export default withKPI(KPIFullModal)
